module.exports = __webpack_public_path__ + "img/kep4-2.3a6d4d30.jpg";